<script setup>
import axios from 'axios'
import { ref, reactive, onMounted } from 'vue'
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isToday from 'dayjs/plugin/isToday'
import Swal from 'sweetalert2'

dayjs.extend(updateLocale)
dayjs.extend(isSameOrBefore)
dayjs.extend(isToday)
dayjs.updateLocale('en', {
  weekStart: 1
})

const props = defineProps({
  department: {
    type: Object,
    required: true
  },
  workPeriods: {
    type: Array,
    required: true
  },
  initWorkPeriod: {
    type: Object,
    required: true
  },
  creatorWorks: {
    type: Array,
    required: true
  }
})

const data = reactive({
  isLoading: false
})

const selectedWorkPeriod = ref(props.initWorkPeriod?.id)

const download = async () => {
  data.isLoading = true
  try {
    const response = await axios.get(
      `/departments/${props.department.id}/import_excel?work_period_id=${selectedWorkPeriod.value}`,
      {
        responseType: 'blob'
      }
    )
    const link = document.createElement('a')
    const blobUrl = URL.createObjectURL(new Blob([response.data]))
    link.href = blobUrl
    const workPeriod = props.workPeriods.find(
      ({ id }) => id === selectedWorkPeriod.value
    )
    link.download = `${dayjs(workPeriod.first_date).format('YYYYMMDD')}-${dayjs(
      workPeriod.last_date
    ).format('YYMMDD')}_${props.department.name}_import_template.xlsx`
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
    data.isLoading = false
  } catch (error) {
    data.isLoading = false
    await Swal.fire({
      icon: 'error',
      title: 'インポート用エクセルのダウンロードに失敗しました',
      text: '',
      confirmButtonText: 'OK',
      confirmButtonColor: '#40BF6C',
      reverseButtons: true,
      allowOutsideClick: false
    })
  }
}

onMounted(async () => {})
</script>

<template>
  <vue-element-loading :active="data.isLoading" is-full-screen />
  <div class="flex flex-row items-center">
    <select
      v-model="selectedWorkPeriod"
      class="mr-4 h-10 items-center rounded-md border border-gray-300 bg-white px-3.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 hover:text-gray-800"
    >
      <option
        v-for="period in props.workPeriods"
        :key="period.id"
        :value="period.id"
      >
        {{ period.name }}
      </option>
    </select>
    <div
      class="flex items-center justify-center rounded-md border border-transparent bg-yellow-500 px-4 py-1.5 font-medium text-white shadow-sm hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-300 focus:ring-offset-2"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="h-5 w-5 pr-1"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
        />
      </svg>
      <button @click="download">インポート用EXCELテンプレート</button>
    </div>
  </div>
</template>
